// // import React, { useState, useRef, useEffect } from 'react';
// // import { apiCall } from '@/api/apiCall';
// // import { toast } from 'sonner';
// // import TotalDubai from '@/assets/img/TotalDubai.png';
// // import { useApiQueue } from '@/hooks/useApiQueue';
// // import { AssetsPanel } from '../../components/shared/AssetsPanel';
// // import carpark1 from '@/assets/img/car-park-1.png'

// // // ═══════════════════════════════════════════════════════════════════════
// // // HELPERS
// // // ═══════════════════════════════════════════════════════════════════════
// // const groupsToFlat = (groups = []) => {
// //   const result = [];
// //   groups.forEach(g => {
// //     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
// //     (g.items || []).forEach(item => {
// //       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
// //     });
// //   });
// //   return result;
// // };

// // const flatToGroups = (flat) => {
// //   const groups = [];
// //   let cur = null;
// //   flat.forEach(a => {
// //     if (a.isCategory) {
// //       if (cur) groups.push(cur);
// //       cur = { group_name: a.name, group_total_qty: a.totalCount || '-', items: [] };
// //     } else if (cur) {
// //       cur.items.push({ item_name: a.name, qty: a.subCount || '-' });
// //     }
// //   });
// //   if (cur) groups.push(cur);
// //   return groups;
// // };


 
// // const isNewDurationFormat = (data) =>
// //   Array.isArray(data?.header_row1) && Array.isArray(data?.header_row2);

// // /**
// //  * Render the NEW complex duration table with rowspan/colspan support.
// //  * Cells can have: value, rowspan, colspan, skip, render_at_row
// //  */
// // const NewDurationTable = ({ durationTable, handleDurationCellNew }) => {
// //   const dd = durationTable.data;

// //   // Build column key order from header_row2 (excluding the skipped "levels_label" sentinel)
// //   const colKeys = dd.header_row2
// //     .filter(h => !h.skip)
// //     .map(h => h.key);

// //   return (
// //     <table className="!border-collapse text-[11px]">
// //       <thead>
// //         {/* Row 1 — grouped headers */}
// //        <tr>
// //   <th
// //     className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left"
// //     style={{ minWidth: '160px' }}
// //   >
// //     PARKING DURATION
// //   </th>

// //   {dd.header_row1
// //     .filter(h => h.label !== 'PARKING DURATION')
// //     .map((h, i) => (
// //       <th
// //         key={i}
// //         colSpan={h.colspan || 1}
// //         className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300"
// //       >
// //         {h.label}
// //       </th>
// //     ))}
// // </tr>
// //         {/* Row 2 — sub-column labels */}
// //        <tr>
// //   {/* 👇 ye new cell */}
// //   <th className="!border !border-black px-3 py-1 font-semibold text-left bg-gray-300">
// //     Levels
// //   </th>

// //   {dd.header_row2
// //     .filter(h => !h.skip)
// //     .map((h, i) => (
// //       <th
// //         key={i}
// //         className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300"
// //       >
// //         {h.label}
// //       </th>
// //     ))}
// // </tr>
// //         {/* Fee band row */}
// //         <tr>
// //           <td className="!border !border-black px-3 py-1 font-bold text-[11px]">
// //             {dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}
// //           </td>
// //           <td
// //             colSpan={dd.fee_band_row?.value_colspan || colKeys.length}
// //             className="!border !border-black px-3 py-1 text-center font-semibold  text-[11px]"
// //           >
// //             {dd.fee_band_row?.value || ''}
// //           </td>
// //         </tr>
// //       </thead>
// //       <tbody>
// //         {dd.rows?.map((row, rIdx) => (
// //           <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-white'}>
// //             {/* Duration label */}
// //             <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>

// //             {/* Data cells — handle skip, rowspan, colspan */}
// //             {colKeys.map((key, cIdx) => {
// //               const cell = row.cells?.[key];
// //               if (!cell) return null;
// //               if (cell.skip) return null; // covered by a previous rowspan

// //               return (
// //                 <td
// //                   key={cIdx}
// //                   rowSpan={cell.rowspan || 1}
// //                   colSpan={cell.colspan || 1}
// //                   className="!border !border-black px-2 py-1 text-center"
// //                 >
// //                   <input
// //                     type="text"
// //                     value={cell.value ?? ''}
// //                     onChange={e => handleDurationCellNew(rIdx, key, e.target.value)}
// //                     className="w-full !border-0 bg-transparent text-center outline-none text-[11px]"
// //                   />
// //                 </td>
// //               );
// //             })}
// //           </tr>
// //         ))}
// //       </tbody>
// //     </table>
// //   );
// // };

// // /**
// //  * Render the LEGACY flat duration table (unchanged from original).
// //  */
// // const LegacyDurationTable = ({ durationTable, handleDurationCell }) => {
// //   const dd = durationTable.data;
// //   return (
// //     <table className="!border-collapse text-[11px]">
// //       <thead>
// //         <tr>
// //           <th className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>PARKING DURATION</th>
// //           {dd.columns?.length > 1
// //             ? <th colSpan={dd.columns.length} className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300">{durationTable.title}</th>
// //             : <th className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '110px' }}>{durationTable.title}</th>
// //           }
// //         </tr>
// //         <tr>
// //           <th className="!border !border-black px-3 py-1 font-bold text-left bg-gray-300">Levels</th>
// //           {dd.columns?.map((col, i) => (
// //             <th key={i} className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300" style={{ minWidth: '90px' }}>{col.label}</th>
// //           ))}
// //         </tr>
// //         <tr>
// //           <td className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-[11px]">FEE BAND STRUCTURE</td>
// //           <td colSpan={dd.columns?.length} className="!border !border-black px-3 py-1 text-center font-semibold bg-gray-300 text-[11px]">{dd.fee_band}</td>
// //         </tr>
// //       </thead>
// //       <tbody>
// //         {dd.rows?.map((row, rIdx) => (
// //           <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-white'}>
// //             <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>
// //             {dd.columns?.map((col, cIdx) => (
// //               <td key={cIdx} className="!border !border-black px-2 py-1 text-center">
// //                 <input type="text" value={row[col.key] ?? ''} onChange={e => handleDurationCell(rIdx, col.key, e.target.value)}
// //                   className="w-full !border-0 bg-transparent text-center outline-none text-[11px]" />
// //               </td>
// //             ))}
// //           </tr>
// //         ))}
// //       </tbody>
// //     </table>
// //   );
// // };

// // // ═══════════════════════════════════════════════════════════════════════
// // // CONFIG — page type se sab kuch milega
// // // ═══════════════════════════════════════════════════════════════════════
// // const DUBAI_PROFILE_CONFIG = {

// //   // ── Total Dubai ──────────────────────────────────────────────────────
// //   total_dubai_airport_profile: {
// //     profileKey:  'total_dubai_airport_profile',
// //     durationKey: 'total_dubai_parking_duration',
// //     assetsKey:   'total_dubai_assets_deployed',
// //     baysKey:     'total_dubai_parking_bays',
// //     membershipKey: 'total_dubai_membership_tariff',
// //     showBaysTable:    true,
// //     showMembership:   true,
// //     profileFallback: {
// //       table_key: 'total_dubai_airport_profile',
// //       title: 'Total Dubai Airport Profile',
// //       data: {
// //         car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '6,415' },
// //         contract_term:     { value: '10 years' },
// //         contract_period:   { start_date: '01.01.2017', end_date: '31.12.2026' },
// //         operational_hours: { value: '24 Hours Per day' },
// //         vat_note:          { value: 'Parking rates are including 05% VAT' },
// //       },
// //     },
// //     baysFallback: {
// //       table_key: 'total_dubai_parking_bays',
// //       title: 'Parking Bays',
// //       data: {
// //         total: '6,415',
// //         rows: [
// //           { label: 'Dubai Airport T1',    value: '1,890' },
// //           { label: 'Dubai Airport T2',    value: '1,751' },
// //           { label: 'Dubai Airport T3',    value: '2,074' },
// //           { label: 'Dubai Airport Cargo', value: '700'   },
// //         ],
// //       },
// //     },
// //     // New-format fallback using the rowspan/colspan structure
// //     durationFallback: {
// //       table_key: 'total_dubai_parking_duration',
// //       title: 'T1 / T2 / CMT / T3',
// //       data: {
// //         header_row1: [
// //           { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
// //           { label: 'T1',  colspan: 2, rowspan: 1 },
// //           { label: 'T2',  colspan: 2, rowspan: 1 },
// //           { label: 'CMT', colspan: 1, rowspan: 1 },
// //           { label: 'T3',  colspan: 1, rowspan: 1 },
// //         ],
// //         header_row2: [
// //           { key: 'levels_label', label: 'Levels', skip: true },
// //           { key: 't1_a', label: 'Car Park A', parent: 'T1' },
// //           { key: 't1_b', label: 'Car Park B', parent: 'T1' },
// //           { key: 't2_a', label: 'Car Park A', parent: 'T2' },
// //           { key: 't2_b', label: 'Car Park B', parent: 'T2' },
// //           { key: 'cmt',  label: 'Car Park',   parent: 'CMT' },
// //           { key: 't3',   label: 'ALL LEVELS', parent: 'T3' },
// //         ],
// //         fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SUPER GATE', value_colspan: 6 },
// //         rows: [
// //           {
// //             duration: '05 - Minutes',
// //             cells: {
// //               t1_a: { value: '5',   rowspan: 1 },
// //               t1_b: { value: '25',  rowspan:4 },
// //               t2_a: { value: '30',  rowspan: 4 },
// //               t2_b: { value: '15',  rowspan: 4 },
// //               cmt:  { value: '10',  rowspan: 4 },
// //               t3:   { value: '5',   rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: '15 - Minutes',
// //             cells: {
// //               t1_a: { value: '15',  rowspan: 1 },
// //               t1_b: { skip: true },
// //               t2_a: { skip: true },
// //               t2_b: { skip: true },
// //               cmt:  { skip: true },
// //               t3:   { value: '15',  rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: '30 - Minutes',
// //             cells: {
// //               t1_a: { value: '30',  rowspan: 1 },
// //               t1_b: { skip: true },
// //               t2_a: { skip: true },
// //               t2_b: { skip: true },
// //               cmt:  { skip: true },
// //               t3:   { value: '30',  rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: '1 - Hour',
// //             cells: {
// //               t1_a: { value: '40',  rowspan: 2 },
// //               t1_b: { value: '30',  skip:true },
// //               t2_a: { value: '40',  skip:true},
// //               t2_b: { value: '20',  skip:true },
// //               cmt:  { value: '15',  skip:true },
// //               t3:   { value: '40',  rowspan: 2 },
// //             },
// //           },
// //           {
// //             duration: '2 - Hours',
// //             cells: {
// //               t1_a: { skip: true },
// //               t1_b: { value: '30',  rowspan: 1 },
// //               t2_a: { value: '40',  rowspan: 1 },
// //               t2_b: { value: '20',  rowspan: 1 },
// //               cmt:  { value: '15',  rowspan: 1 },
// //               t3:   { skip: true },
// //             },
// //           },
// //           {
// //             duration: '3 - Hours',
// //             cells: {
// //               t1_a: { value: '55',  rowspan: 1 },
// //               t1_b: { value: '35',  rowspan: 1 },
// //               t2_a: { value: '55',  rowspan: 1 },
// //               t2_b: { value: '25',  rowspan: 1 },
// //               cmt:  { value: '20',  rowspan: 1 },
// //               t3:   { value: '55',  rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: '4 - Hours',
// //             cells: {
// //               t1_a: { value: '65',  rowspan: 1 },
// //               t1_b: { value: '45',  rowspan: 1 },
// //               t2_a: { value: '65',  rowspan: 1 },
// //               t2_b: { value: '30',  rowspan: 1 },
// //               cmt:  { value: '25',  rowspan: 1 },
// //               t3:   { value: '65',  rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: '1 day',
// //             cells: {
// //               t1_a: { value: '125', rowspan: 1 },
// //               t1_b: { value: '85',  rowspan: 1 },
// //               t2_a: { value: '125', rowspan: 1 },
// //               t2_b: { value: '70',  rowspan: 1 },
// //               cmt:  { value: '70',  rowspan: 1 },
// //               t3:   { value: '125', rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: 'Each additional day',
// //             cells: {
// //               t1_a: { value: '100', rowspan: 1 },
// //               t1_b: { value: '75',  rowspan: 1 },
// //               t2_a: { value: '100', rowspan: 1 },
// //               t2_b: { value: '50',  rowspan: 1 },
// //               cmt:  { value: '50',  rowspan: 1 },
// //               t3:   { value: '100', rowspan: 1 },
// //             },
// //           },
// //           {
// //             duration: 'Loss Ticket Charges',
// //             cells: {
// //               t1_a: { value: '',    rowspan: 1 },
// //               t1_b: { value: '150', colspan: 5 },
// //               t2_a: { skip: true },
// //               t2_b: { skip: true },
// //               cmt:  { skip: true },
// //               t3:   { skip: true },
// //             },
// //           },
// //         ],
// //       },
// //     },
// //     membershipFallback: {
// //       table_key: 'total_dubai_membership_tariff',
// //       title: 'Membership Tariff - excluding 05% VAT',
// //       data: {
// //         columns: ['PARKING AREA', 'PERIOD (MONTHS)', 'Amount'],
// //         rows: [
// //           ['STAFF A PARKING', 'THREE', '3,000'], ['STAFF A PARKING', 'SIX', '6,000'], ['STAFF A PARKING', 'TWELVE', '12,000'],
// //           ['STAFF B PARKING', 'ONE', '79'],       ['STAFF B PARKING', 'THREE', '235'], ['STAFF B PARKING', 'SIX', '470'],
// //           ['STAFF B PARKING', 'TWELVE', '940'],   ['STAFF C PARKING', 'TWELVE', '440'],
// //           ['THIRD PARTY A PARKING', 'THREE', '4,250'], ['THIRD PARTY B PARKING', 'THREE', '625'],
// //           ['THIRD PARTY B PARKING', 'SIX', '1,250'],   ['THIRD PARTY B PARKING', 'TWELVE', '2,500'],
// //           ['GTO TOURIST BUS', 'ONE', '2,500'],    ['GTO TOURIST BUS', 'THREE', '7,500'],
// //           ['GTO TOURIST BUS', 'SIX', '15,000'],   ['GTO TOURIST BUS', 'TWELVE', '30,000'],
// //           ['GTO TOURIST LIMOUSINE', 'THREE', '5,000'],
// //         ],
// //       },
// //     },
// //     assetsFallback: {
// //       table_key: 'total_dubai_assets_deployed',
// //       title: 'Total Dubai',
// //       data: { groups: makeAssetGroups({ ticketDispenser:'55', evDipG100:'40', evG10064:'16', ticketVerifier:'56', apms:'54', apmEts70:'37', apmEts100:'17', pinPad:'90', cardReader:'53', bContactless:'90', rfidReader:'69', ipBarrier:'104', anprCamera:'103', arh:'103', driverDevice:'4', validation:'6' }) },
// //     },
// //   },

// //   dubai_airport_t1_profile: {
// //   profileKey:  'dubai_t1_profile',
// //   durationKey: 'dubai_t1_duration',
// //   assetsKey:   'dubai_t1_assets',
// //   showBaysTable:  false,
// //   showMembership: false,

// //   profileFallback: {
// //     table_key: 'dubai_t1_profile',
// //     title: 'Dubai Airport T1 Profile',
// //     data: {
// //       car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '1,890' },
// //       contract_term:     { value: '10 years' },
// //       contract_period:   { start_date: '01.01.2017', end_date: '31.12.2026' },
// //       operational_hours: { value: '24 Hours Per day' },
// //       vat_note:          { value: 'Rate per Hour – As per below tariff tabel' },
// //       parking_rates_vat: { value: 'Parking rates are including 05% VAT' },
// //     },
// //   },

// //   durationFallback: {
// //     table_key: 'dubai_t1_duration',
// //     title: 'T1',
// //     data: {
// //       header_row1: [
// //         { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
// //         { label: 'T1', colspan: 2, rowspan: 1 },
// //       ],
// //       header_row2: [
// //         { key: 'levels_label', label: 'Levels', skip: true },
// //         { key: 'car_park_a',   label: 'Car Park A', parent: 'T1' },
// //         { key: 'car_park_b',   label: 'Car Park B', parent: 'T1' },
// //       ],
// //       fee_band_row: {
// //         label: 'FEE BAND STRUCTURE',
// //         value: 'SG',
// //         value_colspan: 2,
// //       },
// //       rows: [
// //         {
// //           duration: '05 - Minutes',
// //           cells: {
// //             car_park_a: { value: '5',   rowspan: 1 },
// //             car_park_b: { value: '25',  rowspan: 4 }, // merges 05-min, 15-min, 30-min
// //           },
// //         },
// //         {
// //           duration: '15 - Minutes',
// //           cells: {
// //             car_park_a: { value: '15', rowspan: 1 },
// //             car_park_b: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '30 - Minutes',
// //           cells: {
// //             car_park_a: { value: '30', rowspan: 1 },
// //             car_park_b: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '1 - Hour',
// //           cells: {
// //             car_park_a: { value: '40', rowspan: 2 }, // merges 1-Hour & 2-Hours
// //             car_park_b: { skip:true },
// //           },
// //         },
// //         {
// //           duration: '2 - Hours',
// //           cells: {
// //             car_park_a: { skip: true },
// //             car_park_b: { value: '30', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '3 - Hours',
// //           cells: {
// //             car_park_a: { value: '55', rowspan: 1 },
// //             car_park_b: { value: '35', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '4 - Hours',
// //           cells: {
// //             car_park_a: { value: '65', rowspan: 1 },
// //             car_park_b: { value: '45', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '1 day',
// //           cells: {
// //             car_park_a: { value: '125', rowspan: 1 },
// //             car_park_b: { value: '85',  rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Each additional day',
// //           cells: {
// //             car_park_a: { value: '100', rowspan: 1 },
// //             car_park_b: { value: '75',  rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Loss Ticket Charges',
// //           cells: {
// //             car_park_a: { value: '150', colspan: 2 }, // spans both columns
// //             car_park_b: { skip: true },
// //           },
// //         },
// //       ],
// //     },
// //   },

// //   assetsFallback: {
// //     table_key: 'dubai_t1_assets',
// //     title: 'Dubai Airport T1',
// //     data: {
// //       groups: makeAssetGroups({
// //         ticketDispenser: '19',
// //         evDipG100:       '16',
// //         evG10064:        '6',
// //         ticketVerifier:  '22',
// //         apms:            '17',
// //         apmEts100:       '17',
// //         pinPad:          '33',
// //         cardReader:      '17',
// //         bContactless:    '33',
// //         rfidReader:      '34',
// //         ipBarrier:       '39',
// //         anprCamera:      '38',
// //         arh:             '38',
// //         driverDevice:    '2',
// //         validation:      '2',
// //       }),
// //     },
// //   },
// // },

// //   // ── T2 ────────────────────────────────────────────────────────────────
// //   dubai_airport_t2_profile: {
// //   profileKey:  'dubai_t2_profile',
// //   durationKey: 'dubai_t2_duration',
// //   assetsKey:   'dubai_t2_assets',
// //   showBaysTable:  false,
// //   showMembership: false,

// //   profileFallback: {
// //     table_key: 'dubai_t2_profile',
// //     title: 'Dubai Airport T2 Profile',
// //     data: {
// //       car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '1,751' },
// //       contract_term:     { value: '10 years' },
// //       contract_period:   { start_date: '01.01.2017', end_date: '31.12.2026' },
// //       operational_hours: { value: '24 Hours Per day' },
// //       vat_note:          { value: 'Rate per Hour – As per below tariff tabel' },
// //       parking_rates_vat: { value: 'Parking rates are including 05% VAT' },
// //     },
// //   },

// //   durationFallback: {
// //     table_key: 'dubai_t2_duration',
// //     title: 'T2',
// //     data: {
// //       header_row1: [
// //         { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
// //         { label: 'T2', colspan: 2, rowspan: 1 },
// //       ],
// //       header_row2: [
// //         { key: 'levels_label', label: 'Levels', skip: true },
// //         { key: 'car_park_a',   label: 'Car Park A', parent: 'T2' },
// //         { key: 'car_park_b',   label: 'Car Park B', parent: 'T2' },
// //       ],
// //       fee_band_row: {
// //         label: 'FEE BAND STRUCTURE',
// //         value: 'SG',
// //         value_colspan: 2,
// //       },
// //       rows: [
// //         {
// //           duration: '05 - Minutes',
// //           cells: {
// //             car_park_a: { value: '30', rowspan: 4 }, // merges 05/15/30-min
// //             car_park_b: { value: '15', rowspan: 4 }, // merges 05/15/30-min
// //           },
// //         },
// //         {
// //           duration: '15 - Minutes',
// //           cells: {
// //             car_park_a: { skip: true },
// //             car_park_b: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '30 - Minutes',
// //           cells: {
// //             car_park_a: { skip: true },
// //             car_park_b: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '1 - Hour',
// //           cells: {
// //             car_park_a: { skip:true},
// //             car_park_b: { skip:true},
// //           },
// //         },
// //         {
// //           duration: '2 - Hours',
// //           cells: {
// //             car_park_a: { value: '40', rowspan: 1 },
// //             car_park_b: { value: '20', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '3 - Hours',
// //           cells: {
// //             car_park_a: { value: '55', rowspan: 1 },
// //             car_park_b: { value: '25', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '4 - Hours',
// //           cells: {
// //             car_park_a: { value: '65', rowspan: 1 },
// //             car_park_b: { value: '30', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '1 day',
// //           cells: {
// //             car_park_a: { value: '125', rowspan: 1 },
// //             car_park_b: { value: '70',  rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Each additional day',
// //           cells: {
// //             car_park_a: { value: '100', rowspan: 1 },
// //             car_park_b: { value: '50',  rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Loss Ticket Charges',
// //           cells: {
// //             car_park_a: { value: '150', colspan: 2 }, // spans both columns
// //             car_park_b: { skip: true },
// //           },
// //         },
// //       ],
// //     },
// //   },

// //   assetsFallback: {
// //     table_key: 'dubai_t2_assets',
// //     title: 'Dubai Airport T2',
// //     data: {
// //       groups: makeAssetGroups({
// //         ticketDispenser: '14',
// //         evDipG100:       '7',
// //         evG10064:        '6',
// //         ticketVerifier:  '13',
// //         apms:            '11',
// //         apmEts70:        '11',
// //         pinPad:          '18',
// //         cardReader:      '11',
// //         bContactless:    '18',
// //         rfidReader:      '14',
// //         ipBarrier:       '25',
// //         anprCamera:      '25',
// //         arh:             '25',
// //         validation:      '2',
// //       }),
// //     },
// //   },
// // },

// //   // ── T3 ────────────────────────────────────────────────────────────────
// //   dubai_airport_t3_profile: {
// //   profileKey:  'dubai_t3_profile',
// //   durationKey: 'dubai_t3_duration',
// //   assetsKey:   'dubai_t3_assets',
// //   showBaysTable:  false,
// //   showMembership: false,

// //   profileFallback: {
// //     table_key: 'dubai_t3_profile',
// //     title: 'Dubai Airport T3 Profile',
// //     data: {
// //       car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,074' },
// //       contract_term:     { value: '10 years' },
// //       contract_period:   { start_date: '01.01.2017', end_date: '31.12.2026' },
// //       operational_hours: { value: '24 Hours Per day' },
// //       vat_note:          { value: 'Rate per Hour – As per below tariff tabel' },
// //       parking_rates_vat: { value: 'Parking rates are including 05% VAT' },
// //     },
// //   },

// //   durationFallback: {
// //     table_key: 'dubai_t3_duration',
// //     title: 'T3',
// //     data: {
// //       header_row1: [
// //         { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
// //         { label: 'T3', colspan: 1, rowspan: 1 },
// //       ],
// //       header_row2: [
// //         { key: 'levels_label', label: 'Levels', skip: true },
// //         { key: 'all_levels', label: 'All Levels', parent: 'T3' },
// //       ],
// //       fee_band_row: {
// //         label: 'FEE BAND STRUCTURE',
// //         value: 'SG',
// //         value_colspan: 1,
// //       },
// //       rows: [
// //         {
// //           duration: '05 - Minutes',
// //           cells: {
// //             all_levels: { value: '5', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '15 - Minutes',
// //           cells: {
// //             all_levels: { value: '15', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '30 - Minutes',
// //           cells: {
// //             all_levels: { value: '30', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '1 - Hour',
// //           cells: {
// //             all_levels: { value: '40', rowspan: 2 }, // merges 1-Hour & 2-Hours
// //           },
// //         },
// //         {
// //           duration: '2 - Hours',
// //           cells: {
// //             all_levels: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '3 - Hours',
// //           cells: {
// //             all_levels: { value: '55', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '4 - Hours',
// //           cells: {
// //             all_levels: { value: '65', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '1 day',
// //           cells: {
// //             all_levels: { value: '125', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Each additional day',
// //           cells: {
// //             all_levels: { value: '100', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Loss Ticket Charges',
// //           cells: {
// //             all_levels: { value: '150', rowspan: 1 },
// //           },
// //         },
// //       ],
// //     },
// //   },

// //   assetsFallback: {
// //     table_key: 'dubai_t3_assets',
// //     title: 'Dubai Airport T3',
// //     data: {
// //       groups: makeAssetGroups({
// //         ticketDispenser: '19',
// //         evDipG100:       '14',  // G100 64 Bit
// //         evG10064:        '4',   // wait — image mein T3 Ticket Verifier: EV DIP G100: 14, EV G100 64 Bit: 4
// //         ticketVerifier:  '18',
// //         apms:            '24',
// //         apmEts70:        '24',
// //         pinPad:          '38',
// //         cardReader:      '24',
// //         bContactless:    '38',
// //         rfidReader:      '17',
// //         ipBarrier:       '34',
// //         anprCamera:      '34',
// //         arh:             '34',
// //         driverDevice:    '2',
// //         validation:      '2',
// //       }),
// //     },
// //   },
// // },

// //   // ── Cargo ─────────────────────────────────────────────────────────────
// //   dubai_airport_cargo_profile: {
// //   profileKey:  'dubai_cargo_profile',
// //   durationKey: 'dubai_cargo_duration',
// //   assetsKey:   'dubai_cargo_assets',
// //   showBaysTable:  false,
// //   showMembership: false,

// //   profileFallback: {
// //     table_key: 'dubai_cargo_profile',
// //     title: 'Dubai Airport Cargo Profile',
// //     data: {
// //       car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '700' },
// //       contract_term:     { value: '10 years' },
// //       contract_period:   { start_date: '01.01.2017', end_date: '31.12.2026' },
// //       operational_hours: { value: '24 Hours Per day' },
// //       vat_note:          { value: 'Rate per Hour – As per below tariff tabel' },
// //       parking_rates_vat: { value: 'Parking rates are including 05% VAT' },
// //     },
// //   },

// //   durationFallback: {
// //     table_key: 'dubai_cargo_duration',
// //     title: 'CMT',
// //     data: {
// //       header_row1: [
// //         { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
// //         { label: 'CMT', colspan: 1, rowspan: 1 },
// //       ],
// //       header_row2: [
// //         { key: 'levels_label', label: 'Levels', skip: true },
// //         { key: 'car_park', label: 'Car Park', parent: 'CMT' },
// //       ],
// //       fee_band_row: {
// //         label: 'FEE BAND STRUCTURE',
// //         value: 'SG',
// //         value_colspan: 1,
// //       },
// //       rows: [
// //         {
// //           duration: '05 - Minutes',
// //           cells: {
// //             car_park: { value: '10', rowspan: 4 }, // merges 05/15/30-min & 1-Hour
// //           },
// //         },
// //         {
// //           duration: '15 - Minutes',
// //           cells: {
// //             car_park: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '30 - Minutes',
// //           cells: {
// //             car_park: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '1 - Hour',
// //           cells: {
// //             car_park: { skip: true },
// //           },
// //         },
// //         {
// //           duration: '2 - Hours',
// //           cells: {
// //             car_park: { value: '15', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '3 - Hours',
// //           cells: {
// //             car_park: { value: '20', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '4 - Hours',
// //           cells: {
// //             car_park: { value: '25', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: '1 day',
// //           cells: {
// //             car_park: { value: '70', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Each additional day',
// //           cells: {
// //             car_park: { value: '50', rowspan: 1 },
// //           },
// //         },
// //         {
// //           duration: 'Loss Ticket Charges',
// //           cells: {
// //             car_park: { value: '150', rowspan: 1 },
// //           },
// //         },
// //       ],
// //     },
// //   },

// //   assetsFallback: {
// //     table_key: 'dubai_cargo_assets',
// //     title: 'Dubai Airport Cargo',
// //     data: {
// //       groups: makeAssetGroups({
// //         ticketDispenser: '3',
// //         evDipG100:       '3',   // G100 64 Bit under Ticket Dispenser
// //         evG10064:        '-',
// //         ticketVerifier:  '3',
// //         apms:            '2',
// //         apmEts70:        '2',   // APM ETS-70: 2
// //         pinPad:          '1',
// //         cardReader:      '1',
// //         bContactless:    '1',
// //         rfidReader:      '4',
// //         ipBarrier:       '6',
// //         anprCamera:      '6',
// //         arh:             '6',
// //       }),
// //     },
// //   },
// // },
// // };

// // // ── Asset groups helper ────────────────────────────────────────────────────────
// // function makeAssetGroups(o = {}) {
// //   return [
// //     { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.ticketDispenser ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
// //     { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
// //     { group_name: "APM's",                group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
// //     { group_name: 'PIN Pad',              group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
// //     { group_name: 'Card Reader',          group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
// //     { group_name: 'B-Contactless',        group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
// //     { group_name: 'RFID Reader',          group_total_qty: o.rfidReader      ?? '-', items: [] },
// //     { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier       ?? '-', items: [] },
// //     { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
// //     { group_name: 'Sliding Gate',         group_total_qty: '-',                      items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
// //     { group_name: "PND's",                group_total_qty: '-',                      items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
// //     { group_name: 'Pound Cashier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
// //     { group_name: 'Driver Device',        group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
// //     { group_name: 'Enf Device',           group_total_qty: '-',                      items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
// //     { group_name: 'Validation',           group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.validation ?? '-' }] },
// //     { group_name: 'Printer',              group_total_qty: '-',                      items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
// //     { group_name: 'Tow Truck',            group_total_qty: '-', items: [] },
// //     { group_name: 'Clamp Vehicle',        group_total_qty: '-', items: [] },
// //     { group_name: 'Support Vehicle',      group_total_qty: '-', items: [] },
// //   ];
// // }

// // // ═══════════════════════════════════════════════════════════════════════
// // // MAIN COMPONENT
// // // ═══════════════════════════════════════════════════════════════════════
// // const DubaiAirportProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
// //   const cfg = DUBAI_PROFILE_CONFIG[page?.type];
// //   if (!cfg) return null;

// //   const hasFetchedRef = useRef(false);
// //   const saveRef = useRef(null);
// //   const [isSaving, setIsSaving]               = useState(false);
// //   const [profileTable, setProfileTable]       = useState(cfg.profileFallback);
// //   const [durationTable, setDurationTable]     = useState(cfg.durationFallback);
// //   const [assetsTable, setAssetsTable]         = useState(cfg.assetsFallback);
// //   const [baysTable, setBaysTable]             = useState(cfg.baysFallback || null);
// //   const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
// //   const { enqueue } = useApiQueue();

// //   // ── Fetch ────────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     if (hasFetchedRef.current) return;
// //     hasFetchedRef.current = true;
// //     fetchData();
// //   }, [year, monthNumber, contract, page?.type]);

// //   const fetchData = async () => {
// //     try {
// //       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
// //       if (!res?.success) return;
// //       const data = res?.data || [];
// //       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

// //       setProfileTable(find(cfg.profileKey,  cfg.profileFallback));
// //       setDurationTable(find(cfg.durationKey, cfg.durationFallback));
// //       setAssetsTable(find(cfg.assetsKey,    cfg.assetsFallback));
// //       if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey, cfg.baysFallback));
// //       if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
// //     } catch (err) {
// //       console.error('Fetch error:', err);
// //     }
// //   };

// //   // ── Auto-save ─────────────────────────────────────────────────────────
// //   const autoSave = () => {
// //     if (saveRef.current) clearTimeout(saveRef.current);
// //     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
// //   };

// //   const saveToAPI = async () => {
// //     try {
// //       setIsSaving(true);
// //       const tables = [
// //         { table_key: profileTable.table_key,  title: profileTable.title,  data: profileTable.data  },
// //         { table_key: durationTable.table_key, title: durationTable.title, data: durationTable.data },
// //         { table_key: assetsTable.table_key,   title: assetsTable.title,   data: assetsTable.data   },
// //       ];
// //       if (cfg.showBaysTable  && baysTable)      tables.push({ table_key: baysTable.table_key,       title: baysTable.title,       data: baysTable.data       });
// //       if (cfg.showMembership && membershipTable) tables.push({ table_key: membershipTable.table_key, title: membershipTable.title, data: membershipTable.data });

// //       const res = await apiCall('POST', '/boardpack/add-tables-data', {
// //         contract, year, month: monthNumber, created_by: 1, tables,
// //       });
// //       if (!res?.success) throw new Error(res?.message);
// //     } catch (err) {
// //       console.error('Save error:', err);
// //       toast.error('Failed to save changes');
// //     } finally {
// //       setIsSaving(false);
// //     }
// //   };

// //   // ── Patch helpers ─────────────────────────────────────────────────────
// //   const patchProfile = (field, subField, value) => {
// //     setProfileTable(prev => ({
// //       ...prev,
// //       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
// //     }));
// //     autoSave();
// //   };

// //   // Legacy flat format handler
// //   const handleDurationCell = (rIdx, key, value) => {
// //     setDurationTable(prev => ({
// //       ...prev,
// //       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
// //     }));
// //     autoSave();
// //   };

// //   // New rowspan/colspan format handler — updates cell.value inside rows[].cells
// //   const handleDurationCellNew = (rIdx, colKey, value) => {
// //     setDurationTable(prev => ({
// //       ...prev,
// //       data: {
// //         ...prev.data,
// //         rows: prev.data.rows.map((row, i) => {
// //           if (i !== rIdx) return row;
// //           return {
// //             ...row,
// //             cells: {
// //               ...row.cells,
// //               [colKey]: { ...row.cells?.[colKey], value },
// //             },
// //           };
// //         }),
// //       },
// //     }));
// //     autoSave();
// //   };

// //   const handleBayTotal = (value) => {
// //     setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
// //     autoSave();
// //   };

// //   const handleBayRow = (idx, value) => {
// //     setBaysTable(prev => ({
// //       ...prev,
// //       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) },
// //     }));
// //     autoSave();
// //   };

// //   const handleMembershipCell = (rIdx, cIdx, value) => {
// //     setMembershipTable(prev => ({
// //       ...prev,
// //       data: {
// //         ...prev.data,
// //         rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
// //       },
// //     }));
// //     autoSave();
// //   };

// //   const handleAssetSubCount = (flatIdx, value) => {
// //     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
// //     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
// //     autoSave();
// //   };

// //   const handleAssetTotalCount = (flatIdx, value) => {
// //     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
// //     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
// //     autoSave();
// //   };

// //   // ── Derived ───────────────────────────────────────────────────────────
// //   const pd  = profileTable.data;
// //   const md  = membershipTable?.data;
// //   const bd  = baysTable?.data;
// //   const flatAssets = groupsToFlat(assetsTable.data.groups);
// //   const useNewDurationFormat = isNewDurationFormat(durationTable.data);

// //   // ── RENDER ────────────────────────────────────────────────────────────
// //   return (
// //     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
// //       {/* Header — logo left, title center */}
// //       <div className="flex justify-between items-center mb-2">
// //         <div className="ml-2">
// //           <img src={TotalDubai} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
// //         </div>
// //         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
// //       </div>

// //       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

// //         {/* ══ LEFT ══ */}
// //         <div className="flex-1 pr-4">

// //           {/* Total Bays */}

// //           {/* <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
// //             <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
// //             <span className="text-[12px]">
// //               {pd.car_park_bays?.label}{' '}
// //               <strong>
// //                 <input type="text" value={pd.car_park_bays?.value || ''}
// //                   onChange={e => patchProfile('car_park_bays', 'value', e.target.value)}
// //                   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
// //               </strong>
// //             </span>
// //           </div> */}
// //            <div className="flex items-center gap-2 ">
// //               <div className="w-[34px] h-[34px] flex items-center justify-center">
// //                 <img src={carpark1} alt="Car Park" className="w-full h-full object-contain" />
// //               </div>
// //               <div className="flex items-center gap-2 mb-1 ml-0 mt-2">
// //  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />            <span className="text-[12px]">
// //               {pd.car_park_bays?.label}{' '}
// //               <strong>
// //                 <input type="text" value={pd.car_park_bays?.value || ''}
// //                   onChange={e => patchProfile('car_park_bays', 'value', e.target.value)}
// //                   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
// //               </strong>
// //             </span>
// //           </div>
// //             </div>
          

// //           {/* Contract Term */}
// //           <div className="flex items-center gap-2 mb-1 ml-10">
// //             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
// //             <span className="text-[12px] flex items-center flex-wrap gap-1">
// //               Contract term{' '}
// //               <strong><input type="text" value={pd.contract_term?.value || ''}
// //                 onChange={e => patchProfile('contract_term', 'value', e.target.value)}
// //                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
// //               ; start date{' '}
// //               <strong><input type="text" value={pd.contract_period?.start_date || ''}
// //                 onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
// //                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
// //               {' to '}
// //               <strong><input type="text" value={pd.contract_period?.end_date || ''}
// //                 onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
// //                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
// //             </span>
// //           </div>

// //           {/* Operational Hours */}
// //           <div className="flex items-center gap-2 mb-1 ml-10">
// //             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
// //             <span className="text-[12px]">
// //               Operational Hours{' '}
// //               <strong><input type="text" value={pd.operational_hours?.value || ''}
// //                 onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
// //                 className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
// //             </span>
// //           </div>

// //           {/* Rate / VAT note */}
// //           <div className="flex items-center gap-2 mb-1 ml-10">
// //             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
// //             <span className="text-[12px]">
// //               <input type="text" value={pd.vat_note?.value || ''}
// //                 onChange={e => patchProfile('vat_note', 'value', e.target.value)}
// //                 className="outline-none bg-transparent !border-0 text-[12px] w-64" />
// //             </span>
// //           </div>

        

// //           {/* Second VAT line — only for terminals, not total */}
// //           {pd.parking_rates_vat && (
// //             <div className="flex items-center gap-2 mb-1 ml-10">
// //               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
// //               <span className="text-[12px]">
// //                 <input type="text" value={pd.parking_rates_vat?.value || ''}
// //                   onChange={e => patchProfile('parking_rates_vat', 'value', e.target.value)}
// //                   className="outline-none bg-transparent !border-0 text-[12px] w-64" />
// //               </span>
// //             </div>
// //           )}
// //             <div className="flex items-center gap-2 mb-4 ml-10">
// //            <div className="mr-1 w-3 h-3 rounded-full !border !border-black  flex-shrink-0 bg-red-500" />
// //             <span className="text-[12px]">Assets Deployed</span>
// //           </div>

// //           {/* ── Bays breakdown — only Total Dubai ── */}
// //           {cfg.showBaysTable && bd && (
// //             <div className="ml-4 mb-5">
// //               <table className="!border-collapse text-[11px]">
// //                 <thead>
// //                   <tr>
// //                     <th className="!border !border-black px-4 py-1.5 font-bold text-left bg-gray-300" style={{ minWidth: '160px' }}>Parking Bays</th>
// //                     <th className="!border !border-black px-4 py-1.5 font-bold text-center bg-gray-300" style={{ minWidth: '80px' }}>
// //                       <input type="text" value={bd.total || ''} onChange={e => handleBayTotal(e.target.value)}
// //                         className="font-bold outline-none bg-transparent !border-0 text-center text-[11px] w-16" />
// //                     </th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {bd.rows?.map((row, i) => (
// //                     <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-white'}>
// //                       <td className="!border !border-black px-4 py-1 text-[11px]">{row.label}</td>
// //                       <td className="!border !border-black px-4 py-1 text-right">
// //                         <input type="text" value={row.value || ''} onChange={e => handleBayRow(i, e.target.value)}
// //                           className="outline-none bg-transparent !border-0 text-right text-[11px] w-full" />
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>
// //           )}

// //           <div className='flex flex-row'>
// //             {/* ── Parking Duration Table — auto-detects format ── */}
// //             <div className="ml-4 mb-5 overflow-x-auto">
// //               {useNewDurationFormat
// //                 ? <NewDurationTable
// //                     durationTable={durationTable}
// //                     handleDurationCellNew={handleDurationCellNew}
// //                   />
// //                 : <LegacyDurationTable
// //                     durationTable={durationTable}
// //                     handleDurationCell={handleDurationCell}
// //                   />
// //               }
// //             </div>

// //             {/* ── Membership Table — only Total Dubai ── */}
// //             {cfg.showMembership && md && (
// //               <div className="ml-4">
// //                 <table className="!border-collapse text-[11px]">
// //                   <thead>
// //                     <tr>
// //                       <th colSpan={md.columns?.length} className="!border !border-black px-3 font-bold text-center bg-gray-300">
// //                         {membershipTable.title}
// //                       </th>
// //                     </tr>
// //                     <tr>
// //                       {md.columns?.map((col, i) => (
// //                         <th key={i} className="!border !border-black px-3 font-semibold text-left bg-gray-300"
// //                           style={{ minWidth: i === 0 ? '160px' : i === 1 ? '120px' : '80px' }}>
// //                           {col}
// //                         </th>
// //                       ))}
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {md.rows?.map((row, rIdx) => (
// //                       <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-white'}>
// //                         {row.map((cell, cIdx) => (
// //                           <td key={cIdx} className="!border !border-black px-3">
// //                             <input type="text" value={cell} onChange={e => handleMembershipCell(rIdx, cIdx, e.target.value)}
// //                               className="outline-none bg-transparent !border-0 w-full text-[11px]" />
// //                           </td>
// //                         ))}
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             )}
// //           </div>
// //         </div>

// //         {/* ══ RIGHT — Assets Panel ══ */}
// //                {/* RIGHT SIDE — Reusable AssetsPanel */}
// //         <AssetsPanel

// //           assetsTable={{ title: assetsTable.title }}
// //           flatAssets={flatAssets}
// //           onSubCount={handleAssetSubCount}
// //           onTotalCount={handleAssetTotalCount}
// //         />

// //       </div>

// //       {isSaving && (
// //         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
// //           Saving...
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default DubaiAirportProfile;










// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import TotalDubai from '@/assets/img/TotalDubai.png';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import carpark1 from '@/assets/img/car-park-1.png';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// const isNewDurationFormat = (data) => Array.isArray(data?.header_row1) && Array.isArray(data?.header_row2);

// // ── Asset groups helper ────────────────────────────────────────────────
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.ticketDispenser ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",                group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
//     { group_name: 'PIN Pad',              group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
//     { group_name: 'Card Reader',          group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
//     { group_name: 'B-Contactless',        group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
//     { group_name: 'RFID Reader',          group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
//     { group_name: 'Sliding Gate',         group_total_qty: '-',                      items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's",                group_total_qty: '-',                      items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//     { group_name: 'Pound Cashier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',        group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
//     { group_name: 'Enf Device',           group_total_qty: '-',                      items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//     { group_name: 'Validation',           group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.validation ?? '-' }] },
//     { group_name: 'Printer',              group_total_qty: '-',                      items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//     { group_name: 'Tow Truck',            group_total_qty: '-', items: [] },
//     { group_name: 'Clamp Vehicle',        group_total_qty: '-', items: [] },
//     { group_name: 'Support Vehicle',      group_total_qty: '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // Duration Table Components (unchanged)
// // ═══════════════════════════════════════════════════════════════════════
// const NewDurationTable = ({ durationTable, handleDurationCellNew }) => {
//   const dd = durationTable.data;
//   const colKeys = dd.header_row2.filter(h => !h.skip).map(h => h.key);
//   return (
//     <table className="!border-collapse text-[11px]">
//       <thead>
//         <tr>
//           <th className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left" style={{ minWidth: '160px' }}>PARKING DURATION</th>
//           {dd.header_row1.filter(h => h.label !== 'PARKING DURATION').map((h, i) => (
//             <th key={i} colSpan={h.colspan || 1} className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300">{h.label}</th>
//           ))}
//         </tr>
//         <tr>
//           <th className="!border !border-black px-3 py-1 font-semibold text-left bg-gray-300">Levels</th>
//           {dd.header_row2.filter(h => !h.skip).map((h, i) => (
//             <th key={i} className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300">{h.label}</th>
//           ))}
//         </tr>
//         <tr>
//           <td className="!border !border-black px-3 py-1 font-bold text-[11px]">{dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}</td>
//           <td colSpan={dd.fee_band_row?.value_colspan || colKeys.length} className="!border !border-black px-3 py-1 text-center font-semibold text-[11px]">{dd.fee_band_row?.value || ''}</td>
//         </tr>
//       </thead>
//       <tbody>
//         {dd.rows?.map((row, rIdx) => (
//           <tr key={rIdx}>
//             <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>
//             {colKeys.map((key, cIdx) => {
//               const cell = row.cells?.[key];
//               if (!cell) return null;
//               if (cell.skip) return null;
//               return (
//                 <td key={cIdx} rowSpan={cell.rowspan || 1} colSpan={cell.colspan || 1} className="!border !border-black px-2 py-1 text-center">
//                   <input type="text" value={cell.value ?? ''} onChange={e => handleDurationCellNew(rIdx, key, e.target.value)} className="w-full !border-0 bg-transparent text-center outline-none text-[11px]" />
//                 </td>
//               );
//             })}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

// const LegacyDurationTable = ({ durationTable, handleDurationCell }) => {
//   const dd = durationTable.data;
//   return (
//     <table className="!border-collapse text-[11px]">
//       <thead>
//         <tr>
//           <th className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>PARKING DURATION</th>
//           {dd.columns?.length > 1
//             ? <th colSpan={dd.columns.length} className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300">{durationTable.title}</th>
//             : <th className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '110px' }}>{durationTable.title}</th>
//           }
//         </tr>
//         <tr>
//           <th className="!border !border-black px-3 py-1 font-bold text-left bg-gray-300">Levels</th>
//           {dd.columns?.map((col, i) => (
//             <th key={i} className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300" style={{ minWidth: '90px' }}>{col.label}</th>
//           ))}
//         </tr>
//         <tr>
//           <td className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-[11px]">FEE BAND STRUCTURE</td>
//           <td colSpan={dd.columns?.length} className="!border !border-black px-3 py-1 text-center font-semibold bg-gray-300 text-[11px]">{dd.fee_band}</td>
//         </tr>
//       </thead>
//       <tbody>
//         {dd.rows?.map((row, rIdx) => (
//           <tr key={rIdx}>
//             <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>
//             {dd.columns?.map((col, cIdx) => (
//               <td key={cIdx} className="!border !border-black px-2 py-1 text-center">
//                 <input type="text" value={row[col.key] ?? ''} onChange={e => handleDurationCell(rIdx, col.key, e.target.value)} className="w-full !border-0 bg-transparent text-center outline-none text-[11px]" />
//               </td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG (unchanged — same as original)
// // ═══════════════════════════════════════════════════════════════════════
// const DUBAI_PROFILE_CONFIG = {
//   total_dubai_airport_profile: {
//     profileKey: 'total_dubai_airport_profile', durationKey: 'total_dubai_parking_duration', assetsKey: 'total_dubai_assets_deployed', baysKey: 'total_dubai_parking_bays', membershipKey: 'total_dubai_membership_tariff', showBaysTable: true, showMembership: true,
//     profileFallback: { table_key: 'total_dubai_airport_profile', title: 'Total Dubai Airport Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '6,415' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Parking rates are including 05% VAT' } } },
//     baysFallback: { table_key: 'total_dubai_parking_bays', title: 'Parking Bays', data: { total: '6,415', rows: [{ label: 'Dubai Airport T1', value: '1,890' }, { label: 'Dubai Airport T2', value: '1,751' }, { label: 'Dubai Airport T3', value: '2,074' }, { label: 'Dubai Airport Cargo', value: '700' }] } },
//     durationFallback: { table_key: 'total_dubai_parking_duration', title: 'T1 / T2 / CMT / T3', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T1', colspan: 2, rowspan: 1 }, { label: 'T2', colspan: 2, rowspan: 1 }, { label: 'CMT', colspan: 1, rowspan: 1 }, { label: 'T3', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 't1_a', label: 'Car Park A', parent: 'T1' }, { key: 't1_b', label: 'Car Park B', parent: 'T1' }, { key: 't2_a', label: 'Car Park A', parent: 'T2' }, { key: 't2_b', label: 'Car Park B', parent: 'T2' }, { key: 'cmt', label: 'Car Park', parent: 'CMT' }, { key: 't3', label: 'ALL LEVELS', parent: 'T3' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SUPER GATE', value_colspan: 6 }, rows: [{ duration: '05 - Minutes', cells: { t1_a: { value: '5', rowspan: 1 }, t1_b: { value: '25', rowspan: 4 }, t2_a: { value: '30', rowspan: 4 }, t2_b: { value: '15', rowspan: 4 }, cmt: { value: '10', rowspan: 4 }, t3: { value: '5', rowspan: 1 } } }, { duration: '15 - Minutes', cells: { t1_a: { value: '15', rowspan: 1 }, t1_b: { skip: true }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { value: '15', rowspan: 1 } } }, { duration: '30 - Minutes', cells: { t1_a: { value: '30', rowspan: 1 }, t1_b: { skip: true }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { value: '30', rowspan: 1 } } }, { duration: '1 - Hour', cells: { t1_a: { value: '40', rowspan: 2 }, t1_b: { value: '30', skip: true }, t2_a: { value: '40', skip: true }, t2_b: { value: '20', skip: true }, cmt: { value: '15', skip: true }, t3: { value: '40', rowspan: 2 } } }, { duration: '2 - Hours', cells: { t1_a: { skip: true }, t1_b: { value: '30', rowspan: 1 }, t2_a: { value: '40', rowspan: 1 }, t2_b: { value: '20', rowspan: 1 }, cmt: { value: '15', rowspan: 1 }, t3: { skip: true } } }, { duration: '3 - Hours', cells: { t1_a: { value: '55', rowspan: 1 }, t1_b: { value: '35', rowspan: 1 }, t2_a: { value: '55', rowspan: 1 }, t2_b: { value: '25', rowspan: 1 }, cmt: { value: '20', rowspan: 1 }, t3: { value: '55', rowspan: 1 } } }, { duration: '4 - Hours', cells: { t1_a: { value: '65', rowspan: 1 }, t1_b: { value: '45', rowspan: 1 }, t2_a: { value: '65', rowspan: 1 }, t2_b: { value: '30', rowspan: 1 }, cmt: { value: '25', rowspan: 1 }, t3: { value: '65', rowspan: 1 } } }, { duration: '1 day', cells: { t1_a: { value: '125', rowspan: 1 }, t1_b: { value: '85', rowspan: 1 }, t2_a: { value: '125', rowspan: 1 }, t2_b: { value: '70', rowspan: 1 }, cmt: { value: '70', rowspan: 1 }, t3: { value: '125', rowspan: 1 } } }, { duration: 'Each additional day', cells: { t1_a: { value: '100', rowspan: 1 }, t1_b: { value: '75', rowspan: 1 }, t2_a: { value: '100', rowspan: 1 }, t2_b: { value: '50', rowspan: 1 }, cmt: { value: '50', rowspan: 1 }, t3: { value: '100', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { t1_a: { value: '', rowspan: 1 }, t1_b: { value: '150', colspan: 5 }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { skip: true } } }] } },
//     membershipFallback: { table_key: 'total_dubai_membership_tariff', title: 'Membership Tariff - excluding 05% VAT', data: { columns: ['PARKING AREA', 'PERIOD (MONTHS)', 'Amount'], rows: [['STAFF A PARKING', 'THREE', '3,000'], ['STAFF A PARKING', 'SIX', '6,000'], ['STAFF A PARKING', 'TWELVE', '12,000'], ['STAFF B PARKING', 'ONE', '79'], ['STAFF B PARKING', 'THREE', '235'], ['STAFF B PARKING', 'SIX', '470'], ['STAFF B PARKING', 'TWELVE', '940'], ['STAFF C PARKING', 'TWELVE', '440'], ['THIRD PARTY A PARKING', 'THREE', '4,250'], ['THIRD PARTY B PARKING', 'THREE', '625'], ['THIRD PARTY B PARKING', 'SIX', '1,250'], ['THIRD PARTY B PARKING', 'TWELVE', '2,500'], ['GTO TOURIST BUS', 'ONE', '2,500'], ['GTO TOURIST BUS', 'THREE', '7,500'], ['GTO TOURIST BUS', 'SIX', '15,000'], ['GTO TOURIST BUS', 'TWELVE', '30,000'], ['GTO TOURIST LIMOUSINE', 'THREE', '5,000']] } },
//     assetsFallback: { table_key: 'total_dubai_assets_deployed', title: 'Total Dubai', data: { groups: makeAssetGroups({ ticketDispenser: '55', evDipG100: '40', evG10064: '16', ticketVerifier: '56', apms: '54', apmEts70: '37', apmEts100: '17', pinPad: '90', cardReader: '53', bContactless: '90', rfidReader: '69', ipBarrier: '104', anprCamera: '103', arh: '103', driverDevice: '4', validation: '6' }) } },
//   },
//   dubai_airport_t1_profile: {
//     profileKey: 'dubai_t1_profile', durationKey: 'dubai_t1_duration', assetsKey: 'dubai_t1_assets', showBaysTable: false, showMembership: false,
//     profileFallback: { table_key: 'dubai_t1_profile', title: 'Dubai Airport T1 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '1,890' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
//     durationFallback: { table_key: 'dubai_t1_duration', title: 'T1', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T1', colspan: 2, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park_a', label: 'Car Park A', parent: 'T1' }, { key: 'car_park_b', label: 'Car Park B', parent: 'T1' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 2 }, rows: [{ duration: '05 - Minutes', cells: { car_park_a: { value: '5', rowspan: 1 }, car_park_b: { value: '25', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park_a: { value: '15', rowspan: 1 }, car_park_b: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park_a: { value: '30', rowspan: 1 }, car_park_b: { skip: true } } }, { duration: '1 - Hour', cells: { car_park_a: { value: '40', rowspan: 2 }, car_park_b: { skip: true } } }, { duration: '2 - Hours', cells: { car_park_a: { skip: true }, car_park_b: { value: '30', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park_a: { value: '55', rowspan: 1 }, car_park_b: { value: '35', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park_a: { value: '65', rowspan: 1 }, car_park_b: { value: '45', rowspan: 1 } } }, { duration: '1 day', cells: { car_park_a: { value: '125', rowspan: 1 }, car_park_b: { value: '85', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park_a: { value: '100', rowspan: 1 }, car_park_b: { value: '75', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park_a: { value: '150', colspan: 2 }, car_park_b: { skip: true } } }] } },
//     assetsFallback: { table_key: 'dubai_t1_assets', title: 'Dubai Airport T1', data: { groups: makeAssetGroups({ ticketDispenser: '19', evDipG100: '16', evG10064: '6', ticketVerifier: '22', apms: '17', apmEts100: '17', pinPad: '33', cardReader: '17', bContactless: '33', rfidReader: '34', ipBarrier: '39', anprCamera: '38', arh: '38', driverDevice: '2', validation: '2' }) } },
//   },
//   dubai_airport_t2_profile: {
//     profileKey: 'dubai_t2_profile', durationKey: 'dubai_t2_duration', assetsKey: 'dubai_t2_assets', showBaysTable: false, showMembership: false,
//     profileFallback: { table_key: 'dubai_t2_profile', title: 'Dubai Airport T2 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '1,751' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
//     durationFallback: { table_key: 'dubai_t2_duration', title: 'T2', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T2', colspan: 2, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park_a', label: 'Car Park A', parent: 'T2' }, { key: 'car_park_b', label: 'Car Park B', parent: 'T2' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 2 }, rows: [{ duration: '05 - Minutes', cells: { car_park_a: { value: '30', rowspan: 4 }, car_park_b: { value: '15', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '1 - Hour', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '2 - Hours', cells: { car_park_a: { value: '40', rowspan: 1 }, car_park_b: { value: '20', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park_a: { value: '55', rowspan: 1 }, car_park_b: { value: '25', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park_a: { value: '65', rowspan: 1 }, car_park_b: { value: '30', rowspan: 1 } } }, { duration: '1 day', cells: { car_park_a: { value: '125', rowspan: 1 }, car_park_b: { value: '70', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park_a: { value: '100', rowspan: 1 }, car_park_b: { value: '50', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park_a: { value: '150', colspan: 2 }, car_park_b: { skip: true } } }] } },
//     assetsFallback: { table_key: 'dubai_t2_assets', title: 'Dubai Airport T2', data: { groups: makeAssetGroups({ ticketDispenser: '14', evDipG100: '7', evG10064: '6', ticketVerifier: '13', apms: '11', apmEts70: '11', pinPad: '18', cardReader: '11', bContactless: '18', rfidReader: '14', ipBarrier: '25', anprCamera: '25', arh: '25', validation: '2' }) } },
//   },
//   dubai_airport_t3_profile: {
//     profileKey: 'dubai_t3_profile', durationKey: 'dubai_t3_duration', assetsKey: 'dubai_t3_assets', showBaysTable: false, showMembership: false,
//     profileFallback: { table_key: 'dubai_t3_profile', title: 'Dubai Airport T3 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '2,074' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
//     durationFallback: { table_key: 'dubai_t3_duration', title: 'T3', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T3', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'all_levels', label: 'All Levels', parent: 'T3' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 1 }, rows: [{ duration: '05 - Minutes', cells: { all_levels: { value: '5', rowspan: 1 } } }, { duration: '15 - Minutes', cells: { all_levels: { value: '15', rowspan: 1 } } }, { duration: '30 - Minutes', cells: { all_levels: { value: '30', rowspan: 1 } } }, { duration: '1 - Hour', cells: { all_levels: { value: '40', rowspan: 2 } } }, { duration: '2 - Hours', cells: { all_levels: { skip: true } } }, { duration: '3 - Hours', cells: { all_levels: { value: '55', rowspan: 1 } } }, { duration: '4 - Hours', cells: { all_levels: { value: '65', rowspan: 1 } } }, { duration: '1 day', cells: { all_levels: { value: '125', rowspan: 1 } } }, { duration: 'Each additional day', cells: { all_levels: { value: '100', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { all_levels: { value: '150', rowspan: 1 } } }] } },
//     assetsFallback: { table_key: 'dubai_t3_assets', title: 'Dubai Airport T3', data: { groups: makeAssetGroups({ ticketDispenser: '19', evDipG100: '14', evG10064: '4', ticketVerifier: '18', apms: '24', apmEts70: '24', pinPad: '38', cardReader: '24', bContactless: '38', rfidReader: '17', ipBarrier: '34', anprCamera: '34', arh: '34', driverDevice: '2', validation: '2' }) } },
//   },
//   dubai_airport_cargo_profile: {
//     profileKey: 'dubai_cargo_profile', durationKey: 'dubai_cargo_duration', assetsKey: 'dubai_cargo_assets', showBaysTable: false, showMembership: false,
//     profileFallback: { table_key: 'dubai_cargo_profile', title: 'Dubai Airport Cargo Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '700' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
//     durationFallback: { table_key: 'dubai_cargo_duration', title: 'CMT', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'CMT', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park', label: 'Car Park', parent: 'CMT' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 1 }, rows: [{ duration: '05 - Minutes', cells: { car_park: { value: '10', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park: { skip: true } } }, { duration: '1 - Hour', cells: { car_park: { skip: true } } }, { duration: '2 - Hours', cells: { car_park: { value: '15', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park: { value: '20', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park: { value: '25', rowspan: 1 } } }, { duration: '1 day', cells: { car_park: { value: '70', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park: { value: '50', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park: { value: '150', rowspan: 1 } } }] } },
//     assetsFallback: { table_key: 'dubai_cargo_assets', title: 'Dubai Airport Cargo', data: { groups: makeAssetGroups({ ticketDispenser: '3', evDipG100: '3', evG10064: '-', ticketVerifier: '3', apms: '2', apmEts70: '2', pinPad: '1', cardReader: '1', bContactless: '1', rfidReader: '4', ipBarrier: '6', anprCamera: '6', arh: '6' }) } },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const DubaiAirportProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = DUBAI_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);

//   // ── State ─────────────────────────────────────────────────────────────
//   const [profileTable,    _setProfileTable]    = useState(cfg.profileFallback);
//   const [durationTable,   _setDurationTable]   = useState(cfg.durationFallback);
//   const [assetsTable,     _setAssetsTable]     = useState(cfg.assetsFallback);
//   const [baysTable,       _setBaysTable]       = useState(cfg.baysFallback || null);
//   const [membershipTable, _setMembershipTable] = useState(cfg.membershipFallback || null);

//   // ── FIX: Refs always hold latest state ───────────────────────────────
//   const profileRef    = useRef(cfg.profileFallback);
//   const durationRef   = useRef(cfg.durationFallback);
//   const assetsRef     = useRef(cfg.assetsFallback);
//   const baysRef       = useRef(cfg.baysFallback || null);
//   const membershipRef = useRef(cfg.membershipFallback || null);

//   // ── Wrapped setters ───────────────────────────────────────────────────
//   const setProfileTable = (valOrFn) => {
//     _setProfileTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; profileRef.current = next; return next; });
//   };
//   const setDurationTable = (valOrFn) => {
//     _setDurationTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; durationRef.current = next; return next; });
//   };
//   const setAssetsTable = (valOrFn) => {
//     _setAssetsTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; assetsRef.current = next; return next; });
//   };
//   const setBaysTable = (valOrFn) => {
//     _setBaysTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; baysRef.current = next; return next; });
//   };
//   const setMembershipTable = (valOrFn) => {
//     _setMembershipTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; membershipRef.current = next; return next; });
//   };

//   const { enqueue } = useApiQueue();

//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;
//       setProfileTable(find(cfg.profileKey,   cfg.profileFallback));
//       setDurationTable(find(cfg.durationKey, cfg.durationFallback));
//       setAssetsTable(find(cfg.assetsKey,     cfg.assetsFallback));
//       if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey,         cfg.baysFallback));
//       if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   // FIX: Reads from refs — always latest
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
//       const tables = [
//         { table_key: profileRef.current.table_key,  title: profileRef.current.title,  data: profileRef.current.data  },
//         { table_key: durationRef.current.table_key, title: durationRef.current.title, data: durationRef.current.data },
//         { table_key: assetsRef.current.table_key,   title: assetsRef.current.title,   data: assetsRef.current.data   },
//       ];
//       if (cfg.showBaysTable  && baysRef.current)      tables.push({ table_key: baysRef.current.table_key,       title: baysRef.current.title,       data: baysRef.current.data       });
//       if (cfg.showMembership && membershipRef.current) tables.push({ table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data });

//       const res = await apiCall('POST', '/boardpack/add-tables-data', { contract, year, month: monthNumber, created_by: 1, tables });
//       if (!res?.success) throw new Error(res?.message);
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({ ...prev, data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value } }));
//     autoSave();
//   };

//   const handleDurationCell = (rIdx, key, value) => {
//     setDurationTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) } }));
//     autoSave();
//   };

//   const handleDurationCellNew = (rIdx, colKey, value) => {
//     setDurationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((row, i) => i !== rIdx ? row : { ...row, cells: { ...row.cells, [colKey]: { ...row.cells?.[colKey], value } } }) },
//     }));
//     autoSave();
//   };

//   const handleBayTotal = (value) => {
//     setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
//     autoSave();
//   };

//   const handleBayRow = (idx, value) => {
//     setBaysTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) } }));
//     autoSave();
//   };

//   const handleMembershipCell = (rIdx, cIdx, value) => {
//     setMembershipTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r) } }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     // FIX: use assetsRef.current for latest groups
//     const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     // FIX: use assetsRef.current for latest groups
//     const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Derived ───────────────────────────────────────────────────────────
//   const pd  = profileTable.data;
//   const md  = membershipTable?.data;
//   const bd  = baysTable?.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const useNewDurationFormat = isNewDurationFormat(durationTable.data);

//   // ── RENDER ────────────────────────────────────────────────────────────
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
//       <div className="flex justify-between items-center mb-2">
//         <div className="ml-2"><img src={TotalDubai} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//         <div className="flex-1 pr-4">

//           <div className="flex items-center gap-2">
//             <div className="w-[34px] h-[34px] flex items-center justify-center">
//               <img src={carpark1} alt="Car Park" className="w-full h-full object-contain" />
//             </div>
//             <div className="flex items-center gap-2 mb-1 ml-0 mt-2">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px]">
//                 {pd.car_park_bays?.label}{' '}
//                 <strong><input type="text" value={pd.car_park_bays?.value || ''} onChange={e => patchProfile('car_park_bays', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//               </span>
//             </div>
//           </div>

//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px] flex items-center flex-wrap gap-1">
//               Contract term{' '}
//               <strong><input type="text" value={pd.contract_term?.value || ''} onChange={e => patchProfile('contract_term', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
//               ; start date{' '}
//               <strong><input type="text" value={pd.contract_period?.start_date || ''} onChange={e => patchProfile('contract_period', 'start_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//               {' to '}
//               <strong><input type="text" value={pd.contract_period?.end_date || ''} onChange={e => patchProfile('contract_period', 'end_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//             </span>
//           </div>

//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Operational Hours{' '}
//               <strong><input type="text" value={pd.operational_hours?.value || ''} onChange={e => patchProfile('operational_hours', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//             </span>
//           </div>

//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               <input type="text" value={pd.vat_note?.value || ''} onChange={e => patchProfile('vat_note', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-64" />
//             </span>
//           </div>

//           {pd.parking_rates_vat && (
//             <div className="flex items-center gap-2 mb-1 ml-10">
//               <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//               <span className="text-[12px]">
//                 <input type="text" value={pd.parking_rates_vat?.value || ''} onChange={e => patchProfile('parking_rates_vat', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-64" />
//               </span>
//             </div>
//           )}

//           <div className="flex items-center gap-2 mb-4 ml-10">
//             <div className="mr-1 w-3 h-3 rounded-full !border !border-black flex-shrink-0 bg-red-500" />
//             <span className="text-[12px]">Assets Deployed</span>
//           </div>

//           {cfg.showBaysTable && bd && (
//             <div className="ml-4 mb-5">
//               <table className="!border-collapse text-[11px]">
//                 <thead>
//                   <tr>
//                     <th className="!border !border-black px-4 py-1.5 font-bold text-left bg-gray-300" style={{ minWidth: '160px' }}>Parking Bays</th>
//                     <th className="!border !border-black px-4 py-1.5 font-bold text-center bg-gray-300" style={{ minWidth: '80px' }}>
//                       <input type="text" value={bd.total || ''} onChange={e => handleBayTotal(e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-center text-[11px] w-16" />
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {bd.rows?.map((row, i) => (
//                     <tr key={i}>
//                       <td className="!border !border-black px-4 py-1 text-[11px]">{row.label}</td>
//                       <td className="!border !border-black px-4 py-1 text-right">
//                         <input type="text" value={row.value || ''} onChange={e => handleBayRow(i, e.target.value)} className="outline-none bg-transparent !border-0 text-right text-[11px] w-full" />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           <div className="flex flex-row">
//             <div className="ml-4 mb-5 ">
//               {useNewDurationFormat
//                 ? <NewDurationTable durationTable={durationTable} handleDurationCellNew={handleDurationCellNew} />
//                 : <LegacyDurationTable durationTable={durationTable} handleDurationCell={handleDurationCell} />
//               }
//             </div>

//             {cfg.showMembership && md && (
//               <div className="ml-4">
//                 <table className="!border-collapse text-[11px]">
//                   <thead>
//                     <tr>
//                       <th colSpan={md.columns?.length} className="!border !border-black px-3 font-bold text-center bg-gray-300">{membershipTable.title}</th>
//                     </tr>
//                     <tr>
//                       {md.columns?.map((col, i) => (
//                         <th key={i} className="!border !border-black px-3 font-semibold text-left bg-gray-300" style={{ minWidth: i === 0 ? '160px' : i === 1 ? '120px' : '80px' }}>{col}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {md.rows?.map((row, rIdx) => (
//                       <tr key={rIdx}>
//                         {row.map((cell, cIdx) => (
//                           <td key={cIdx} className="!border !border-black px-3">
//                             <input type="text" value={cell} onChange={e => handleMembershipCell(rIdx, cIdx, e.target.value)} className="outline-none bg-transparent !border-0 w-full text-[11px]" />
//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>

//         <AssetsPanel
//           assetsTable={{ title: assetsTable.title }}
//           flatAssets={flatAssets}
//           onSubCount={handleAssetSubCount}
//           onTotalCount={handleAssetTotalCount}
//         />
//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">Saving...</div>
//       )} */}
//     </div>
//   );
// };

// export default DubaiAirportProfile;












import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import TotalDubai from '@/assets/img/TotalDubai.png';
import { useApiQueue } from '@/hooks/useApiQueue';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import carpark1 from '@/assets/img/car-park-1.png';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

const isNewDurationFormat = (data) => Array.isArray(data?.header_row1) && Array.isArray(data?.header_row2);

// ── Asset groups helper ────────────────────────────────────────────────
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.ticketDispenser ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",                group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
    { group_name: 'PIN Pad',              group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
    { group_name: 'Card Reader',          group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
    { group_name: 'B-Contactless',        group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
    { group_name: 'RFID Reader',          group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
    { group_name: 'Sliding Gate',         group_total_qty: '-',                      items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's",                group_total_qty: '-',                      items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
    { group_name: 'Pound Cashier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',        group_total_qty: o.driverDevice    ?? '-', items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
    { group_name: 'Enf Device',           group_total_qty: '-',                      items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
    { group_name: 'Validation',           group_total_qty: o.validation      ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.validation ?? '-' }] },
    { group_name: 'Printer',              group_total_qty: '-',                      items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
    { group_name: 'Tow Truck',            group_total_qty: '-', items: [] },
    { group_name: 'Clamp Vehicle',        group_total_qty: '-', items: [] },
    { group_name: 'Support Vehicle',      group_total_qty: '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// Duration Table Components (unchanged)
// ═══════════════════════════════════════════════════════════════════════
const NewDurationTable = ({ durationTable, handleDurationCellNew }) => {
  const dd = durationTable.data;
  const colKeys = dd.header_row2.filter(h => !h.skip).map(h => h.key);
  return (
    <table className="!border-collapse text-[11px]">
      <thead>
        <tr>
          <th className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left" style={{ minWidth: '160px' }}>PARKING DURATION</th>
          {dd.header_row1.filter(h => h.label !== 'PARKING DURATION').map((h, i) => (
            <th key={i} colSpan={h.colspan || 1} className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300">{h.label}</th>
          ))}
        </tr>
        <tr>
          <th className="!border !border-black px-3 py-1 font-semibold text-left bg-gray-300">Levels</th>
          {dd.header_row2.filter(h => !h.skip).map((h, i) => (
            <th key={i} className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300">{h.label}</th>
          ))}
        </tr>
        <tr>
          <td className="!border !border-black px-3 py-1 font-bold text-[11px]">{dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}</td>
          <td colSpan={dd.fee_band_row?.value_colspan || colKeys.length} className="!border !border-black px-3 py-1 text-center font-semibold text-[11px]">{dd.fee_band_row?.value || ''}</td>
        </tr>
      </thead>
      <tbody>
        {dd.rows?.map((row, rIdx) => (
          <tr key={rIdx}>
            <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>
            {colKeys.map((key, cIdx) => {
              const cell = row.cells?.[key];
              if (!cell) return null;
              if (cell.skip) return null;
              return (
                <td key={cIdx} rowSpan={cell.rowspan || 1} colSpan={cell.colspan || 1} className="!border !border-black px-2 py-1 text-center">
                  <input type="text" value={cell.value ?? ''} onChange={e => handleDurationCellNew(rIdx, key, e.target.value)} className="w-full !border-0 bg-transparent text-center outline-none text-[11px]" />
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const LegacyDurationTable = ({ durationTable, handleDurationCell }) => {
  const dd = durationTable.data;
  return (
    <table className="!border-collapse text-[11px]">
      <thead>
        <tr>
          <th className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>PARKING DURATION</th>
          {dd.columns?.length > 1
            ? <th colSpan={dd.columns.length} className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300">{durationTable.title}</th>
            : <th className="!border !border-black px-3 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '110px' }}>{durationTable.title}</th>
          }
        </tr>
        <tr>
          <th className="!border !border-black px-3 py-1 font-bold text-left bg-gray-300">Levels</th>
          {dd.columns?.map((col, i) => (
            <th key={i} className="!border !border-black px-3 py-1 font-semibold text-center bg-gray-300" style={{ minWidth: '90px' }}>{col.label}</th>
          ))}
        </tr>
        <tr>
          <td className="!border !border-black px-3 py-1 font-bold bg-gray-300 text-[11px]">FEE BAND STRUCTURE</td>
          <td colSpan={dd.columns?.length} className="!border !border-black px-3 py-1 text-center font-semibold bg-gray-300 text-[11px]">{dd.fee_band}</td>
        </tr>
      </thead>
      <tbody>
        {dd.rows?.map((row, rIdx) => (
          <tr key={rIdx}>
            <td className="!border !border-black px-3 py-1 text-[11px]">{row.duration}</td>
            {dd.columns?.map((col, cIdx) => (
              <td key={cIdx} className="!border !border-black px-2 py-1 text-center">
                <input type="text" value={row[col.key] ?? ''} onChange={e => handleDurationCell(rIdx, col.key, e.target.value)} className="w-full !border-0 bg-transparent text-center outline-none text-[11px]" />
               </td>
            ))}
           </tr>
        ))}
      </tbody>
    </table>
  );
};

// ═══════════════════════════════════════════════════════════════════════
// CONFIG (unchanged — same as original)
// ═══════════════════════════════════════════════════════════════════════
const DUBAI_PROFILE_CONFIG = {
  total_dubai_airport_profile: {
    profileKey: 'total_dubai_airport_profile', durationKey: 'total_dubai_parking_duration', assetsKey: 'total_dubai_assets_deployed', baysKey: 'total_dubai_parking_bays', membershipKey: 'total_dubai_membership_tariff', showBaysTable: true, showMembership: true,
    profileFallback: { table_key: 'total_dubai_airport_profile', title: 'Total Dubai Airport Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '6,415' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Parking rates are including 05% VAT' } } },
    baysFallback: { table_key: 'total_dubai_parking_bays', title: 'Parking Bays', data: { total: '6,415', rows: [{ label: 'Dubai Airport T1', value: '1,890' }, { label: 'Dubai Airport T2', value: '1,751' }, { label: 'Dubai Airport T3', value: '2,074' }, { label: 'Dubai Airport Cargo', value: '700' }] } },
    durationFallback: { table_key: 'total_dubai_parking_duration', title: 'T1 / T2 / CMT / T3', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T1', colspan: 2, rowspan: 1 }, { label: 'T2', colspan: 2, rowspan: 1 }, { label: 'CMT', colspan: 1, rowspan: 1 }, { label: 'T3', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 't1_a', label: 'Car Park A', parent: 'T1' }, { key: 't1_b', label: 'Car Park B', parent: 'T1' }, { key: 't2_a', label: 'Car Park A', parent: 'T2' }, { key: 't2_b', label: 'Car Park B', parent: 'T2' }, { key: 'cmt', label: 'Car Park', parent: 'CMT' }, { key: 't3', label: 'ALL LEVELS', parent: 'T3' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SUPER GATE', value_colspan: 6 }, rows: [{ duration: '05 - Minutes', cells: { t1_a: { value: '5', rowspan: 1 }, t1_b: { value: '25', rowspan: 4 }, t2_a: { value: '30', rowspan: 4 }, t2_b: { value: '15', rowspan: 4 }, cmt: { value: '10', rowspan: 4 }, t3: { value: '5', rowspan: 1 } } }, { duration: '15 - Minutes', cells: { t1_a: { value: '15', rowspan: 1 }, t1_b: { skip: true }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { value: '15', rowspan: 1 } } }, { duration: '30 - Minutes', cells: { t1_a: { value: '30', rowspan: 1 }, t1_b: { skip: true }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { value: '30', rowspan: 1 } } }, { duration: '1 - Hour', cells: { t1_a: { value: '40', rowspan: 2 }, t1_b: { value: '30', skip: true }, t2_a: { value: '40', skip: true }, t2_b: { value: '20', skip: true }, cmt: { value: '15', skip: true }, t3: { value: '40', rowspan: 2 } } }, { duration: '2 - Hours', cells: { t1_a: { skip: true }, t1_b: { value: '30', rowspan: 1 }, t2_a: { value: '40', rowspan: 1 }, t2_b: { value: '20', rowspan: 1 }, cmt: { value: '15', rowspan: 1 }, t3: { skip: true } } }, { duration: '3 - Hours', cells: { t1_a: { value: '55', rowspan: 1 }, t1_b: { value: '35', rowspan: 1 }, t2_a: { value: '55', rowspan: 1 }, t2_b: { value: '25', rowspan: 1 }, cmt: { value: '20', rowspan: 1 }, t3: { value: '55', rowspan: 1 } } }, { duration: '4 - Hours', cells: { t1_a: { value: '65', rowspan: 1 }, t1_b: { value: '45', rowspan: 1 }, t2_a: { value: '65', rowspan: 1 }, t2_b: { value: '30', rowspan: 1 }, cmt: { value: '25', rowspan: 1 }, t3: { value: '65', rowspan: 1 } } }, { duration: '1 day', cells: { t1_a: { value: '125', rowspan: 1 }, t1_b: { value: '85', rowspan: 1 }, t2_a: { value: '125', rowspan: 1 }, t2_b: { value: '70', rowspan: 1 }, cmt: { value: '70', rowspan: 1 }, t3: { value: '125', rowspan: 1 } } }, { duration: 'Each additional day', cells: { t1_a: { value: '100', rowspan: 1 }, t1_b: { value: '75', rowspan: 1 }, t2_a: { value: '100', rowspan: 1 }, t2_b: { value: '50', rowspan: 1 }, cmt: { value: '50', rowspan: 1 }, t3: { value: '100', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { t1_a: { value: '', rowspan: 1 }, t1_b: { value: '150', colspan: 5 }, t2_a: { skip: true }, t2_b: { skip: true }, cmt: { skip: true }, t3: { skip: true } } }] } },
    membershipFallback: { table_key: 'total_dubai_membership_tariff', title: 'Membership Tariff - excluding 05% VAT', data: { columns: ['PARKING AREA', 'PERIOD (MONTHS)', 'Amount'], rows: [['STAFF A PARKING', 'THREE', '3,000'], ['STAFF A PARKING', 'SIX', '6,000'], ['STAFF A PARKING', 'TWELVE', '12,000'], ['STAFF B PARKING', 'ONE', '79'], ['STAFF B PARKING', 'THREE', '235'], ['STAFF B PARKING', 'SIX', '470'], ['STAFF B PARKING', 'TWELVE', '940'], ['STAFF C PARKING', 'TWELVE', '440'], ['THIRD PARTY A PARKING', 'THREE', '4,250'], ['THIRD PARTY B PARKING', 'THREE', '625'], ['THIRD PARTY B PARKING', 'SIX', '1,250'], ['THIRD PARTY B PARKING', 'TWELVE', '2,500'], ['GTO TOURIST BUS', 'ONE', '2,500'], ['GTO TOURIST BUS', 'THREE', '7,500'], ['GTO TOURIST BUS', 'SIX', '15,000'], ['GTO TOURIST BUS', 'TWELVE', '30,000'], ['GTO TOURIST LIMOUSINE', 'THREE', '5,000']] } },
    assetsFallback: { table_key: 'total_dubai_assets_deployed', title: 'Total Dubai', data: { groups: makeAssetGroups({ ticketDispenser: '55', evDipG100: '40', evG10064: '16', ticketVerifier: '56', apms: '54', apmEts70: '37', apmEts100: '17', pinPad: '90', cardReader: '53', bContactless: '90', rfidReader: '69', ipBarrier: '104', anprCamera: '103', arh: '103', driverDevice: '4', validation: '6' }) } },
  },
  dubai_airport_t1_profile: {
    profileKey: 'dubai_t1_profile', durationKey: 'dubai_t1_duration', assetsKey: 'dubai_t1_assets', showBaysTable: false, showMembership: false,
    profileFallback: { table_key: 'dubai_t1_profile', title: 'Dubai Airport T1 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '1,890' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
    durationFallback: { table_key: 'dubai_t1_duration', title: 'T1', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T1', colspan: 2, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park_a', label: 'Car Park A', parent: 'T1' }, { key: 'car_park_b', label: 'Car Park B', parent: 'T1' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 2 }, rows: [{ duration: '05 - Minutes', cells: { car_park_a: { value: '5', rowspan: 1 }, car_park_b: { value: '25', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park_a: { value: '15', rowspan: 1 }, car_park_b: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park_a: { value: '30', rowspan: 1 }, car_park_b: { skip: true } } }, { duration: '1 - Hour', cells: { car_park_a: { value: '40', rowspan: 2 }, car_park_b: { skip: true } } }, { duration: '2 - Hours', cells: { car_park_a: { skip: true }, car_park_b: { value: '30', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park_a: { value: '55', rowspan: 1 }, car_park_b: { value: '35', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park_a: { value: '65', rowspan: 1 }, car_park_b: { value: '45', rowspan: 1 } } }, { duration: '1 day', cells: { car_park_a: { value: '125', rowspan: 1 }, car_park_b: { value: '85', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park_a: { value: '100', rowspan: 1 }, car_park_b: { value: '75', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park_a: { value: '150', colspan: 2 }, car_park_b: { skip: true } } }] } },
    assetsFallback: { table_key: 'dubai_t1_assets', title: 'Dubai Airport T1', data: { groups: makeAssetGroups({ ticketDispenser: '19', evDipG100: '16', evG10064: '6', ticketVerifier: '22', apms: '17', apmEts100: '17', pinPad: '33', cardReader: '17', bContactless: '33', rfidReader: '34', ipBarrier: '39', anprCamera: '38', arh: '38', driverDevice: '2', validation: '2' }) } },
  },
  dubai_airport_t2_profile: {
    profileKey: 'dubai_t2_profile', durationKey: 'dubai_t2_duration', assetsKey: 'dubai_t2_assets', showBaysTable: false, showMembership: false,
    profileFallback: { table_key: 'dubai_t2_profile', title: 'Dubai Airport T2 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '1,751' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
    durationFallback: { table_key: 'dubai_t2_duration', title: 'T2', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T2', colspan: 2, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park_a', label: 'Car Park A', parent: 'T2' }, { key: 'car_park_b', label: 'Car Park B', parent: 'T2' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 2 }, rows: [{ duration: '05 - Minutes', cells: { car_park_a: { value: '30', rowspan: 4 }, car_park_b: { value: '15', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '1 - Hour', cells: { car_park_a: { skip: true }, car_park_b: { skip: true } } }, { duration: '2 - Hours', cells: { car_park_a: { value: '40', rowspan: 1 }, car_park_b: { value: '20', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park_a: { value: '55', rowspan: 1 }, car_park_b: { value: '25', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park_a: { value: '65', rowspan: 1 }, car_park_b: { value: '30', rowspan: 1 } } }, { duration: '1 day', cells: { car_park_a: { value: '125', rowspan: 1 }, car_park_b: { value: '70', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park_a: { value: '100', rowspan: 1 }, car_park_b: { value: '50', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park_a: { value: '150', colspan: 2 }, car_park_b: { skip: true } } }] } },
    assetsFallback: { table_key: 'dubai_t2_assets', title: 'Dubai Airport T2', data: { groups: makeAssetGroups({ ticketDispenser: '14', evDipG100: '7', evG10064: '6', ticketVerifier: '13', apms: '11', apmEts70: '11', pinPad: '18', cardReader: '11', bContactless: '18', rfidReader: '14', ipBarrier: '25', anprCamera: '25', arh: '25', validation: '2' }) } },
  },
  dubai_airport_t3_profile: {
    profileKey: 'dubai_t3_profile', durationKey: 'dubai_t3_duration', assetsKey: 'dubai_t3_assets', showBaysTable: false, showMembership: false,
    profileFallback: { table_key: 'dubai_t3_profile', title: 'Dubai Airport T3 Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '2,074' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
    durationFallback: { table_key: 'dubai_t3_duration', title: 'T3', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'T3', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'all_levels', label: 'All Levels', parent: 'T3' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 1 }, rows: [{ duration: '05 - Minutes', cells: { all_levels: { value: '5', rowspan: 1 } } }, { duration: '15 - Minutes', cells: { all_levels: { value: '15', rowspan: 1 } } }, { duration: '30 - Minutes', cells: { all_levels: { value: '30', rowspan: 1 } } }, { duration: '1 - Hour', cells: { all_levels: { value: '40', rowspan: 2 } } }, { duration: '2 - Hours', cells: { all_levels: { skip: true } } }, { duration: '3 - Hours', cells: { all_levels: { value: '55', rowspan: 1 } } }, { duration: '4 - Hours', cells: { all_levels: { value: '65', rowspan: 1 } } }, { duration: '1 day', cells: { all_levels: { value: '125', rowspan: 1 } } }, { duration: 'Each additional day', cells: { all_levels: { value: '100', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { all_levels: { value: '150', rowspan: 1 } } }] } },
    assetsFallback: { table_key: 'dubai_t3_assets', title: 'Dubai Airport T3', data: { groups: makeAssetGroups({ ticketDispenser: '19', evDipG100: '14', evG10064: '4', ticketVerifier: '18', apms: '24', apmEts70: '24', pinPad: '38', cardReader: '24', bContactless: '38', rfidReader: '17', ipBarrier: '34', anprCamera: '34', arh: '34', driverDevice: '2', validation: '2' }) } },
  },
  dubai_airport_cargo_profile: {
    profileKey: 'dubai_cargo_profile', durationKey: 'dubai_cargo_duration', assetsKey: 'dubai_cargo_assets', showBaysTable: false, showMembership: false,
    profileFallback: { table_key: 'dubai_cargo_profile', title: 'Dubai Airport Cargo Profile', data: { car_park_bays: { label: 'Total Off Street Car Park Bays', value: '700' }, contract_term: { value: '10 years' }, contract_period: { start_date: '01.01.2017', end_date: '31.12.2026' }, operational_hours: { value: '24 Hours Per day' }, vat_note: { value: 'Rate per Hour – As per below tariff tabel' }, parking_rates_vat: { value: 'Parking rates are including 05% VAT' } } },
    durationFallback: { table_key: 'dubai_cargo_duration', title: 'CMT', data: { header_row1: [{ label: 'PARKING DURATION', colspan: 1, rowspan: 2 }, { label: 'CMT', colspan: 1, rowspan: 1 }], header_row2: [{ key: 'levels_label', label: 'Levels', skip: true }, { key: 'car_park', label: 'Car Park', parent: 'CMT' }], fee_band_row: { label: 'FEE BAND STRUCTURE', value: 'SG', value_colspan: 1 }, rows: [{ duration: '05 - Minutes', cells: { car_park: { value: '10', rowspan: 4 } } }, { duration: '15 - Minutes', cells: { car_park: { skip: true } } }, { duration: '30 - Minutes', cells: { car_park: { skip: true } } }, { duration: '1 - Hour', cells: { car_park: { skip: true } } }, { duration: '2 - Hours', cells: { car_park: { value: '15', rowspan: 1 } } }, { duration: '3 - Hours', cells: { car_park: { value: '20', rowspan: 1 } } }, { duration: '4 - Hours', cells: { car_park: { value: '25', rowspan: 1 } } }, { duration: '1 day', cells: { car_park: { value: '70', rowspan: 1 } } }, { duration: 'Each additional day', cells: { car_park: { value: '50', rowspan: 1 } } }, { duration: 'Loss Ticket Charges', cells: { car_park: { value: '150', rowspan: 1 } } }] } },
    assetsFallback: { table_key: 'dubai_cargo_assets', title: 'Dubai Airport Cargo', data: { groups: makeAssetGroups({ ticketDispenser: '3', evDipG100: '3', evG10064: '-', ticketVerifier: '3', apms: '2', apmEts70: '2', pinPad: '1', cardReader: '1', bContactless: '1', rfidReader: '4', ipBarrier: '6', anprCamera: '6', arh: '6' }) } },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const DubaiAirportProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = DUBAI_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);

  // ── State ─────────────────────────────────────────────────────────────
  const [profileTable,    _setProfileTable]    = useState(cfg.profileFallback);
  const [durationTable,   _setDurationTable]   = useState(cfg.durationFallback);
  const [assetsTable,     _setAssetsTable]     = useState(cfg.assetsFallback);
  const [baysTable,       _setBaysTable]       = useState(cfg.baysFallback || null);
  const [membershipTable, _setMembershipTable] = useState(cfg.membershipFallback || null);

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.car_park_bays?.value ?? '0';

  // ── FIX: Refs always hold latest state ───────────────────────────────
  const profileRef    = useRef(cfg.profileFallback);
  const durationRef   = useRef(cfg.durationFallback);
  const assetsRef     = useRef(cfg.assetsFallback);
  const baysRef       = useRef(cfg.baysFallback || null);
  const membershipRef = useRef(cfg.membershipFallback || null);

  // ── Wrapped setters ───────────────────────────────────────────────────
  const setProfileTable = (valOrFn) => {
    _setProfileTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; profileRef.current = next; return next; });
  };
  const setDurationTable = (valOrFn) => {
    _setDurationTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; durationRef.current = next; return next; });
  };
  const setAssetsTable = (valOrFn) => {
    _setAssetsTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; assetsRef.current = next; return next; });
  };
  const setBaysTable = (valOrFn) => {
    _setBaysTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; baysRef.current = next; return next; });
  };
  const setMembershipTable = (valOrFn) => {
    _setMembershipTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; membershipRef.current = next; return next; });
  };

  const { enqueue } = useApiQueue();

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      let secondApiParams;
      switch (page?.type) {
        case 'total_dubai_airport_profile':
          secondApiParams = { contract: "1100", year: year, month: month, type: "airport" };
          break;
        case 'dubai_airport_t1_profile':
          secondApiParams = { contract: "1100001", year: year, month: month, type: "airport" };
          break;
        case 'dubai_airport_t2_profile':
          secondApiParams = { contract: "1100002", year: year, month: month, type: "airport" };
          break;
        case 'dubai_airport_t3_profile':
          secondApiParams = { contract: "1100003", year: year, month: month, type: "airport" };
          break;
        case 'dubai_airport_cargo_profile':
          secondApiParams = { contract: "1100004", year: year, month: month, type: "airport" };
          break;
        default:
          secondApiParams = { contract: "1100", year: year, month: month, type: "airport" };
      }
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        setProfileTable(find(cfg.profileKey,   cfg.profileFallback));
        setDurationTable(find(cfg.durationKey, cfg.durationFallback));
        setAssetsTable(find(cfg.assetsKey,     cfg.assetsFallback));
        if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey,         cfg.baysFallback));
        if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // FIX: Reads from refs — always latest
  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      const tables = [
        { table_key: profileRef.current.table_key,  title: profileRef.current.title,  data: profileRef.current.data  },
        { table_key: durationRef.current.table_key, title: durationRef.current.title, data: durationRef.current.data },
        { table_key: assetsRef.current.table_key,   title: assetsRef.current.title,   data: assetsRef.current.data   },
      ];
      if (cfg.showBaysTable  && baysRef.current)      tables.push({ table_key: baysRef.current.table_key,       title: baysRef.current.title,       data: baysRef.current.data       });
      if (cfg.showMembership && membershipRef.current) tables.push({ table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data });

      const res = await apiCall('POST', '/boardpack/add-tables-data', { contract, year, month: monthNumber, created_by: 1, tables });
      if (!res?.success) throw new Error(res?.message);
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({ ...prev, data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value } }));
    autoSave();
  };

  const handleDurationCell = (rIdx, key, value) => {
    setDurationTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) } }));
    autoSave();
  };

  const handleDurationCellNew = (rIdx, colKey, value) => {
    setDurationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((row, i) => i !== rIdx ? row : { ...row, cells: { ...row.cells, [colKey]: { ...row.cells?.[colKey], value } } }) },
    }));
    autoSave();
  };

  const handleBayTotal = (value) => {
    setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
    autoSave();
  };

  const handleBayRow = (idx, value) => {
    setBaysTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) } }));
    autoSave();
  };

  const handleMembershipCell = (rIdx, cIdx, value) => {
    setMembershipTable(prev => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r) } }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Derived ───────────────────────────────────────────────────────────
  const pd  = profileTable.data;
  const md  = membershipTable?.data;
  const bd  = baysTable?.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const useNewDurationFormat = isNewDurationFormat(durationTable.data);

  // ── RENDER ────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen p-8 bg-white">
      <div className="flex justify-between items-center mb-2">
        <div className="ml-2"><img src={TotalDubai} alt="Total Dubai Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">
        <div className="flex-1 pr-4">

          {/* 🔥 READ-ONLY Total Bays */}
          <div className="flex items-center gap-2">
            <div className="w-[34px] h-[34px] flex items-center justify-center">
              <img src={carpark1} alt="Car Park" className="w-full h-full object-contain" />
            </div>
            <div className="flex items-center gap-2 mb-1 ml-0 mt-2">
              <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
              <span className="text-[12px]">
                {pd.car_park_bays?.label}{' '}
                <strong>
                  <input 
                    type="text" 
                    value={effectiveTotalBays}
                    readOnly 
                    disabled
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
                  />
                </strong>
              </span>
            </div>
          </div>

          {/* Contract Term - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] flex items-center flex-wrap gap-1">
              Contract term{' '}
              <strong><input type="text" value={pd.contract_term?.value || ''} onChange={e => patchProfile('contract_term', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
              ; start date{' '}
              <strong><input type="text" value={pd.contract_period?.start_date || ''} onChange={e => patchProfile('contract_period', 'start_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
              {' to '}
              <strong><input type="text" value={pd.contract_period?.end_date || ''} onChange={e => patchProfile('contract_period', 'end_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
            </span>
          </div>

          {/* Operational Hours - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Operational Hours{' '}
              <strong><input type="text" value={pd.operational_hours?.value || ''} onChange={e => patchProfile('operational_hours', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
            </span>
          </div>

          {/* VAT Note - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              <input type="text" value={pd.vat_note?.value || ''} onChange={e => patchProfile('vat_note', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-64" />
            </span>
          </div>

          {/* Parking Rates VAT - Editable */}
          {pd.parking_rates_vat && (
            <div className="flex items-center gap-2 mb-1 ml-10">
              <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
              <span className="text-[12px]">
                <input type="text" value={pd.parking_rates_vat?.value || ''} onChange={e => patchProfile('parking_rates_vat', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-64" />
              </span>
            </div>
          )}

          {/* Assets Deployed */}
          <div className="flex items-center gap-2 mb-4 ml-10">
            <div className="mr-1 w-3 h-3 rounded-full !border !border-black flex-shrink-0 bg-red-500" />
            <span className="text-[12px]">Assets Deployed</span>
          </div>

          {/* Bays Table - Individual bays EDITABLE, total READ-ONLY */}
          {cfg.showBaysTable && bd && (
            <div className="ml-4 mb-5">
              <table className="!border-collapse text-[11px]">
                <thead>
                  <tr>
                    <th className="!border !border-black px-4 py-1.5 font-bold text-left bg-gray-300" style={{ minWidth: '160px' }}>Parking Bays</th>
                    <th className="!border !border-black px-4 py-1.5 font-bold text-center bg-gray-300" style={{ minWidth: '80px' }}>
                      {/* 🔥 READ-ONLY total bays */}
                      <input type="text" value={effectiveTotalBays} readOnly disabled className="font-bold outline-none bg-transparent !border-0 text-center text-[11px] w-16 cursor-default" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bd.rows?.map((row, i) => (
                    <tr key={i}>
                      <td className="!border !border-black px-4 py-1 text-[11px]">{row.label}</td>
                      <td className="!border !border-black px-4 py-1 text-right">
                        <input type="text" value={row.value || ''} onChange={e => handleBayRow(i, e.target.value)} className="outline-none bg-transparent !border-0 text-right text-[11px] w-full" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Duration Tables - Editable */}
          <div className="flex flex-row">
            <div className="ml-4 mb-5 ">
              {useNewDurationFormat
                ? <NewDurationTable durationTable={durationTable} handleDurationCellNew={handleDurationCellNew} />
                : <LegacyDurationTable durationTable={durationTable} handleDurationCell={handleDurationCell} />
              }
            </div>

            {/* Membership Table - Editable */}
            {cfg.showMembership && md && (
              <div className="ml-4">
                <table className="!border-collapse text-[11px]">
                  <thead>
                    <tr>
                      <th colSpan={md.columns?.length} className="!border !border-black px-3 font-bold text-center bg-gray-300">{membershipTable.title}</th>
                    </tr>
                    <tr>
                      {md.columns?.map((col, i) => (
                        <th key={i} className="!border !border-black px-3 font-semibold text-left bg-gray-300" style={{ minWidth: i === 0 ? '160px' : i === 1 ? '120px' : '80px' }}>{col}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {md.rows?.map((row, rIdx) => (
                      <tr key={rIdx}>
                        {row.map((cell, cIdx) => (
                          <td key={cIdx} className="!border !border-black px-3">
                            <input type="text" value={cell} onChange={e => handleMembershipCell(rIdx, cIdx, e.target.value)} className="outline-none bg-transparent !border-0 w-full text-[11px]" />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Assets Panel - Editable */}
        <AssetsPanel
          assetsTable={{ title: assetsTable.title }}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />
      </div>
    </div>
  );
};

export default DubaiAirportProfile;